import { useNavigate } from "react-router"

type ManageLocationStudentProps = {
    onBack: () => void
}
export const ManageLocationStudentPage = ({ onBack }: ManageLocationStudentProps) => {
    const navigate = useNavigate()
    return (
        <div>
            Student table
        </div>
    )
}